export enum Language {
    NL = "nl-NL",
    EN = "en-GB",
    FI = "fi-FI",
    SV = "sv-SE",
    CrowdingInContext = "zu-ZA"
}

export const availableLanguages = [Language.NL, Language.EN];

export const defaultLanguage = Language.NL;

export const fallbackLanguage = "en";
